// extracted by mini-css-extract-plugin
export default {"campusInfo":"ProgramVersionSelect_campusInfo__RA+ZM","labelWrapper":"ProgramVersionSelect_labelWrapper__C4hxR"};